module.exports = __webpack_public_path__ + "static/img/Tutorial sin texto Redpie4 (1)-12.ef717c6c.jpg";